import "./FlightSearch.module.css";
import Header from "@/reusable_sections/Header";
import FlightSearchWidget from "./sections/FlightSearchWidget";
import Footer from "@/reusable_sections/Footer";
export default function FlightSearchPage() {
  return <div>
      <Header />
      <FlightSearchWidget />
      <Footer />
    </div>;
}